var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{ref:"player",staticClass:"player",attrs:{"id":"player"}}),_c('v-icon',{staticClass:"highlight_off",staticStyle:{"display":"none"},on:{"click":_vm.back}},[_vm._v("highlight_off")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }